import { SortingState } from '@tanstack/react-table';
import { ExpectedQueryData } from 'components/table/hooks/useServerFilteredTable';
import { getPaginationParams } from 'components/table/utils/pagination';
import { getSortParam } from 'components/table/utils/sorting';
import {
  CustomTemplate,
  GetCustomTemplatesResponse,
} from 'models/automation/CustomTemplates';
import API from 'services/API';

type QueryReturnType = ExpectedQueryData<CustomTemplate>;

export const CUSTOM_TEMPLATES_BASE_QUERY_KEY = 'custom-templates';

export const CUSTOM_TEMPLATES_SORTING = {
  name: 'SORT_BY_NAME',
  messagingType: 'SORT_BY_MESSAGING_TYPE',
};

export const customTemplatesQuery = ({
  pageIndex,
  pageSize,
  sorting,
  name,
}: {
  pageIndex: number;
  pageSize: number;
  sorting: SortingState;
  name?: string;
}) => ({
  queryKey: [
    CUSTOM_TEMPLATES_BASE_QUERY_KEY,
    'list',
    { pageIndex, pageSize, sorting, name },
  ],
  queryFn: async (): Promise<QueryReturnType> => {
    const sort = getSortParam(sorting, CUSTOM_TEMPLATES_SORTING);

    const response = await API.get<GetCustomTemplatesResponse>(
      `/api/internal/automation/custom-templates${
        // there seems to be an issue with Axios double encoding params, as said here: https://github.com/axios/axios/issues/463, this fixes it:
        name ? `?name=${encodeURIComponent(name)}` : ''
      }`,
      {
        params: {
          ...getPaginationParams({ pageIndex, pageSize }),
          ...(sort ? { _sort: sort.sort, _sortDirection: sort.direction } : {}),
        },
      },
    );

    const { templates, _metadata } = response.data;

    return {
      data: templates,
      _metadata,
    };
  },
  enabled: true,
});
